import React, { useState, useEffect } from 'react';

import { HashRouter as Router, useLocation } from 'react-router-dom';

import { NavigationProvider } from './contexts/navigation';
import { UserProvider } from './contexts/user';


import { useScreenSizeClass } from './utils/media-query';
import { Content } from './Content';
import { UnauthenticatedContent } from './UnauthenticatedContent';

import 'devexpress-gantt/dist/dx-gantt.css';
import './styles.scss';
import './theme/theme';
import { useThemeContext, ThemeContext } from './theme/theme';
import deMessages from "devextreme/localization/messages/de.json";
import { locale, loadMessages } from "devextreme/localization";
import { MsalProvider, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { PushNotificationProvider } from './contexts/pushNotifications';


function RootApp() {
  console.log('RootApp loaded');
  const isLoginForm = [
    'login',
    'reset-password',
    'create-account',
  ].includes(useLocation().pathname.substring(1));

  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();
  const [isInitializing, setIsInitializing] = useState(true);

  // Wait for MSAL to finish initializing
  useEffect(() => {
    if (inProgress === 'none') {
      setIsInitializing(false);
    }
  }, [inProgress]);

  // Show loading while MSAL is initializing
  if (isInitializing || inProgress !== 'none') {
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    return <Content />;
  } else {
    console.log('User is not authenticated, showing unauthenticated content');
    return <UnauthenticatedContent />;
  }


}

export const App = ({ pca }) => {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();
  loadMessages(deMessages);
  locale(navigator.language);
  console.log('Load Router/App');
  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <MsalProvider instance={pca}>
          <PushNotificationProvider>
            <NavigationProvider>
              <UserProvider>
                <div className={`app ${screenSizeClass}`}>
                  {
                    themeContext.isLoaded ? <RootApp /> : ''
                  }
                </div>
              </UserProvider>
            </NavigationProvider>
          </PushNotificationProvider>
        </MsalProvider>
      </ThemeContext.Provider>
    </Router>
  );
};
